import styled from 'styled-components';
import theme from 'common/theme';

export const MachineUsageCardContainer = styled.div`

    .card-header {
        margin-bottom: 12px;
    }

    .label-group {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .label {
            flex: 1;
        }
        .label, .value {
            color: ${theme.colors.gray800};
            font-size: 0.75rem;
            font-weight: 600;
            line-height: normal;
        }
    }

    .checkbox {
        width: 14px;
        height: 14px;
        background-color: #ccc;
        margin-right: 6px;
    }

    .machine-list {
        border-top: 2px solid ${theme.colors.gray500};
        padding-top: 8px;
    }

    .machine-row {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        border-bottom: 1px solid ${theme.colors.gray300};
    }

    .machine-row:last-child {
        border-bottom: none;
    }
        
    .machine-name, .machine-hours {
        font-size: 0.75rem;
        font-weight: 600;
    }
`;
